import * as actionTypes from "./actionTypes";
import axios, { accountInstance as accountAxios } from "../../services/axios";
import { setMessage } from "./message";
import { getPersonalInfoData } from "./personalAccount/personalInformation";

export const loginProcessing = () => {
  return {
    type: actionTypes.LOGIN_PROCESSING,
  };
};

export const loginSuccess = (payload) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    user: payload,
    message: "success",
  };
};

export const loginFailed = (errorStatus) => {
  return {
    type: actionTypes.LOGIN_FAILED,
    message: "error",
    errorStatus: errorStatus
  };
};

export const setIsIlliquid = (isIlliquid) => {
  return {
    type: actionTypes.IS_ILLIQUID,
    isIlliquid: isIlliquid,
  };
}

export const checkIfContactsAreVerified = (hasNotConfirmedContact) => {
  return {
    type: actionTypes.ARE_CONTACTS_VERIFIED,
    hasNotConfirmedContact: hasNotConfirmedContact
  }
}

export const setLoginThatEqualsPassword = (loginThatEqualsPassword) => {
  return {
    type: actionTypes.LOGIN_EQUALS_PASSWORD,
    loginThatEqualsPassword
  }
}

export const getIsIlliquid = () => (dispatch) =>
  new Promise(function (resolve, reject) {
    axios
      .get(`/api/v1/personal-information/illiquid-data`)
      .then((response) => {
        dispatch(setIsIlliquid(response.data))
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const login = (username, password, rememberDevice) => {
  return (dispatch) => {
    dispatch(loginProcessing());
    localStorage.setItem("rememberDevice", rememberDevice);
    axios
      .post(`api/v1/auth/login`, {
        username: username,
        password: password,
        rememberDevice
      })
      .then((response) => {
        const redirectUrl = response.data.redirectUrl;
        if (response.status === 280) {
          window.location.href = redirectUrl;
        } else {
          dispatch(checkAccount(response))
        }
      })
      .catch((error) => {
        if (error?.response?.data?.code === "LOGIN_EQUALS_PASSWORD") {
          dispatch(setLoginThatEqualsPassword(username))
        } else {
          dispatch(loginFailed(error?.response?.status ?? 401));
        }
      });
  };
};

export const checkAccount = (response) => (dispatch) => {
  if (response.data.authorities.indexOf("ROLE_ADMIN") === -1) {
    axios
      .get(`/api/v1/personal-information/illiquid-data`)
      .then((responseIsIlliquid) => {
        if (responseIsIlliquid.data) dispatch(setIsIlliquid(responseIsIlliquid.data))
        else {
          dispatch(checkIfContactsAreVerified(response.data.hasNotConfirmedContact))
          dispatch(getPersonalInfoData())
          dispatch(loginSuccess(response.data))
        }
      })
      .catch((error) => dispatch(loginFailed(error?.response?.status ?? 401)))
  } else {
    dispatch(loginSuccess(response.data));
  }
}

export const logout = () => (dispatch) =>
  new Promise(function (resolve, reject) {
    axios
      .get(`api/v1/auth/logout`)
      .then(() => {
        if (localStorage.getItem("user"))
          localStorage.removeItem("user")
        if (localStorage.getItem("_expiredTime"))
          localStorage.removeItem("_expiredTime")
        dispatch({
          type: actionTypes.LOGOUT,
        });

        resolve();
      })
      .catch((error) => {
        dispatch(setMessage({ type: 'error', text: "Не удалось выйти из аккаунта." }))
        reject(error);
      });
  });
